// extracted by mini-css-extract-plugin
module.exports = {"container":"RetailerSearch_container__hR__L","searchInput":"RetailerSearch_searchInput__Tq_nS"};